import { render } from "./Admin.vue?vue&type=template&id=39a3ea0e&bindings={}"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
script.render = render

export default script